/**
 * Exercise Glossary (NS) — legend filtering.
 *
 * The sticky legend itself is pure CSS (`position: sticky`); this file exists
 * only so tapping a muscle chip narrows the grid to the movements that train it.
 *
 * Filtering is an enhancement, never a requirement: the section renders every
 * exercise at full contrast before this runs, and with JS unavailable the chips
 * are simply inert labels. Nothing is ever removed from the DOM — matching is
 * expressed as a dimmed class so the grid never reflows under the reader.
 *
 * One delegated listener on the document rather than per-section wiring: the
 * section may appear more than once on a page, and the theme editor swaps
 * section markup wholesale on every edit. Delegation survives both without
 * teardown bookkeeping, and the guard below keeps a duplicated <script src>
 * from binding twice.
 */
(function () {
  if (window.nsExerciseGlossaryBound) return;
  window.nsExerciseGlossaryBound = true;

  function clearFilter(root) {
    root.querySelectorAll('[data-exg-chip]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', 'false');
    });
    root.querySelectorAll('[data-exg-item]').forEach(function (item) {
      item.classList.remove('is-dimmed');
    });
  }

  function applyFilter(root, muscle) {
    root.querySelectorAll('[data-exg-chip]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(chip.dataset.muscle === muscle));
    });

    root.querySelectorAll('[data-exg-item]').forEach(function (item) {
      var muscles = (item.dataset.muscles || '').split(/\s+/);
      item.classList.toggle('is-dimmed', muscles.indexOf(muscle) === -1);
    });
  }

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-exg-chip]');
    if (!chip) return;

    var root = chip.closest('.ns-exg');
    if (!root) return;

    // Second tap on the active chip clears the filter, so the chip row doubles
    // as its own reset and the section needs no separate "show all" control.
    if (chip.getAttribute('aria-pressed') === 'true') {
      clearFilter(root);
    } else {
      applyFilter(root, chip.dataset.muscle);
    }
  });
})();
